module.exports = __webpack_public_path__ + "img/LATIN10_07.6f281544.jpg";